import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Button } from 'Components/ComponentLibrary/ExternalLibraries';

const styles = (theme) => ({
  root: {
    borderRadius: theme.radius.xl,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightFacetBold,
    padding: theme.spacing(0.25, 2),
  },
  variantDefault: {
    color: theme.palette.facet.primaryBlue,
    backgroundColor: theme.palette.facet.accentBlue21,
    '&:hover': {
      backgroundColor: theme.palette.facet.accentBlue20,
    },
  },
});

const FullyRoundedButton = ({
  className,
  classes,
  children,
  variant,
  ...rest
}) => {
  return (
    <Button
      className={classNames(classes.root, className, {
        [classes.variantDefault]: variant === 'default',
      })}
      disableElevation
      padding={'dense'}
      {...rest}
    >
      {children}
    </Button>
  );
};

FullyRoundedButton.defaultProps = {
  className: '',
  variant: 'default',
};

FullyRoundedButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
};

export default withStyles(styles)(FullyRoundedButton);
